import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  EditOutlined,
  DeleteOutline,
  Search,
  AccountBalanceOutlined,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

//Services
import AvailablebanksApi from "Services/Availablebanks";

//Modals
import BanksAddModal from "Pages/Modals/Availablebanks/Create";
import BanksUpdateModal from "Pages/Modals/Availablebanks/Update";
import BanksDeleteDialog from "Pages/Modals/Availablebanks/Delete";

const Available_banks = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [customerId, setCustomerId] = useState("");

  //Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(1);
  const [searchText, setSearchText] = useState("");

  //Modals
  const [addPassenderModal, setAddPassengerModal] = useState(false);
  const handleOpenAddPassengerModal = () => setAddPassengerModal(true);
  const handleCloseAddPassengerModal = () => {
    setAddPassengerModal(false);
    getbanks();
  };

  const [updatePassenderModal, setUpdatePassengerModal] = useState(false);
  const handleOpenUpdatePassengerModal = (rowItem) => {
    setCustomerId(rowItem?._id);
    setUpdatePassengerModal(true);
  };
  const handleCloseUpdatePassengerModal = () => {
    setUpdatePassengerModal(false);
    getbanks();
  };

  const [deletePassengerModal, setdeletePassengerModal] = useState(false);
  const handleOpenDeletePassengerModal = (rowItem) => {
    setCustomerId(rowItem?._id);
    setdeletePassengerModal(true);
  };
  const handleCloseDeleteServiceModal = () => {
    setdeletePassengerModal(false);
    getbanks();
  };

  // Get Bank list api
  const getbanks = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalRecords(res?.data?.data?.totalRecords || res?.data?.data?.data?.length || 1);
        setRow(res?.data?.data?.data || []);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      setRow([]);
    };
    const params = { page, limit: pageSize, search: searchText };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    AvailablebanksApi
      .getbanksList(params)
      .then(onSuccess, onFailure);
  }, [page, pageSize, searchText, demoaccount_id, dispatch]);

  const getallbanks = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data || []);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = () => {
      setbulkrow([]);
    };
    const params = { page: 1, limit: "unlimited", search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    AvailablebanksApi
      .getbanksList(params)
      .then(onSuccess, onFailure);
  }, [demoaccount_id]);

  useEffect(() => {
    getbanks();
    getallbanks();
  }, [getbanks, getallbanks]);

  const calculateSno = (pageIndex, pSize, index) => {
    return (pageIndex - 1) * pSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    bankName: data?.bankName || "-",
    branchCode: data?.branchCode || "-",
    row: data,
  }));

  const sourceBulk = bulkrow && bulkrow.length > 0 ? bulkrow : row;
  const bulkdataRows = _.map(sourceBulk || [], (data, index) => ({
    sno: index + 1,
    bankName: data?.bankName || "-",
    branchCode: data?.branchCode || "-",
    row: data,
  }));

  const formatteddatas = dataRows.map((r) => ({
    "S.NO": r.sno,
    "Bank Name": r.bankName,
    "Branch Code": r.branchCode,
  }));

  const handleDownloadAll = () => {
    const bulkformatteddatas = bulkdataRows.map((r) => ({
      "S.NO": r.sno,
      "Bank Name": r.bankName,
      "Branch Code": r.branchCode,
    }));
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "AvailableBanksList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopy = () => {
    const columnWidths = [5, 30, 20];
    const padText = (text, width) => (text ?? "").toString().padEnd(width, " ");
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("Bank Name", columnWidths[1]),
      padText("Branch Code", columnWidths[2]),
    ].join("");

    const rows = dataRows
      .map((r) =>
        [
          padText(r.sno, columnWidths[0]),
          padText(r.bankName, columnWidths[1]),
          padText(r.branchCode, columnWidths[2]),
        ].join("")
      )
      .join("\n");

    const formattedContent = [header, rows].join("\n");
    navigator.clipboard.writeText(formattedContent).then(() => {
      dispatch(
        showSnackbar({
          message: "Copied table to clipboard!",
          variant: "success",
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "AvailableBanks");
    XLSX.writeFile(workbook, "AvailableBanksList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "AvailableBanksList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((r) => [r.sno, r.bankName, r.branchCode]);
    doc.autoTable({
      head: [["S.NO", "Bank Name", "Branch Code"]],
      body: tableData,
    });
    doc.save("AvailableBanksList.pdf");
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPage(1);
  };

  // Pagination Logic
  const totalPagesCount = Math.ceil(totalRecords / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;

    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) {
        pages.push(i);
      }
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [
          0,
          "...",
          totalPagesCount - 3,
          totalPagesCount - 2,
          totalPagesCount - 1,
        ];
      } else {
        pages = [
          0,
          "...",
          internalPage - 1,
          internalPage,
          internalPage + 1,
          "...",
          totalPagesCount - 1,
        ];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }

      return (
        <Button
          key={item}
          className={
            internalPage === item
              ? classes.pageButtonActive
              : classes.pageButton
          }
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header Container */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>Available Banks</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Available Banks</span>
        </Typography>
      </Box>

      {/* Actions and Search Bar Row */}
      <Box className={classes.actionRow}>
        <Box className={classes.searchWrapper}>
          <Search className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search"
            value={searchText}
            onChange={handleSearchChange}
            className={classes.searchInput}
          />
        </Box>

        <Box style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          {/* Download/Copy bar */}
          <Box className={classes.exportGroup}>
            <Button className={classes.exportButton} onClick={handleCopy}>
              Copy
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadExcel}>
              Excel
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadCSV}>
              CSV
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadPDF}>
              PDF
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadAll}>
              Download All
            </Button>
          </Box>

          {!demoaccount_id && (
            <Button
              variant="contained"
              className={classes.addCustomerButton}
              onClick={handleOpenAddPassengerModal}
              startIcon={<AccountBalanceOutlined />}
            >
              Add Bank
            </Button>
          )}
        </Box>
      </Box>

      {/* Data Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 0.5 }}>
                S.No
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 2 }}>
                Bank Name
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.5 }}>
                Branch Code
              </TableCell>
              {!demoaccount_id && (
                <TableCell className={classes.tableHeaderCell} style={{ flex: 1.5, textAlign: "right", justifyContent: "flex-end" }}>
                  Actions
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell} style={{ flex: 0.5 }}>
                  {rowItem.sno}
                </TableCell>
                <TableCell
                  className={`${classes.tableCell} ${classes.boldText}`}
                  style={{ flex: 2 }}
                >
                  {rowItem.bankName}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1.5 }}>
                  {rowItem.branchCode}
                </TableCell>
                {!demoaccount_id && (
                  <TableCell className={classes.tableCell} style={{ flex: 1.5, textAlign: "right", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <Box
                      component="span"
                      className={classes.actionButton}
                      onClick={() => handleOpenUpdatePassengerModal(rowItem.row)}
                    >
                      <EditOutlined fontSize="small" /> Edit
                    </Box>
                    <Box
                      component="span"
                      className={classes.actionDeleteButton}
                      onClick={() => handleOpenDeletePassengerModal(rowItem.row)}
                    >
                      <DeleteOutline fontSize="small" /> Delete
                    </Box>
                  </TableCell>
                )}
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={demoaccount_id ? 3 : 4} style={{ textAlign: "center", padding: "32px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalRecords)} of {totalRecords} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />

            {renderPagination()}

            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <BanksAddModal
        openDialog={addPassenderModal}
        handleClose={handleCloseAddPassengerModal}
      />
      <BanksUpdateModal
        openDialog={updatePassenderModal}
        id={customerId}
        handleClose={handleCloseUpdatePassengerModal}
      />
      <BanksDeleteDialog
        openDialog={deletePassengerModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      />
    </Box>
  );
};

export default Available_banks;
